var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "menu_block" },
    [
      _c("transition", { attrs: { name: "slide-fade", mode: "out-in" } }, [
        _vm.docs_create.length > 0
          ? _c(
              "ul",
              { staticClass: "row imc_box" },
              _vm._l(_vm.docs_create, function (item) {
                return _c(
                  "li",
                  {
                    staticClass:
                      "mt-3 mb-3 col-md-4 col-xs-6 col-lg-3 col-xl-2",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "bg-primary-500 color-primary-500",
                        class: _vm.is_active(item),
                        attrs: { href: item.url, title: item.title },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.setActiveMenu(item)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "menu_item menu_item rounded hover-bg shadow-hover text-center shadow-sm border",
                          },
                          [
                            _c("div", { staticClass: "icon" }, [
                              _c("i", { staticClass: "fal", class: item.icon }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "content" }, [
                              _c("h5", { staticClass: "name" }, [
                                _vm._v(_vm._s(item.title)),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }